module.exports = __webpack_public_path__ + "static/oguh-b54500b1113db2509d29d6fe38163573.png";